import React, { useState } from "react";
import { Autocomplete } from "../autocomplete";
import { usePlaceAutocomplete } from "./hooks";
import type { PlaceAutocompleteProps } from "./types";

// The inner component assumes the context is available
export const PlaceAutocomplete: React.FC<PlaceAutocompleteProps> = ({
	onPlaceSelect,
	placeholder = "Enter a location",
	className = "",
	inputProps = {},
	selectedItems = [],
	onItemRemove,
	showChips = false,
	filterField = false,
	onSelectionMade,
	initialValue = "", // Use initialValue for single selection
	autoFocus = false,
	...props
}) => {
	const [isValueSelected, setIsValueSelected] = useState(false);

	const { inputValue, suggestionItems, handleInputChange, handlePlaceSelect, clearInput, isReady } =
		usePlaceAutocomplete(onPlaceSelect, isValueSelected, onSelectionMade, initialValue);

	const selectedAutocompleteItems = selectedItems.map(item => ({
		id: item.id,
		text: item.displayName,
		isPlaceholder: false,
	}));

	//debug
	// if (!isReady) {
	// 	return (
	// 		<div className={`${className} p-3 border border-gray-300 rounded-lg bg-gray-50`}>
	// 			<div className="text-sm text-gray-500">
	// 				Places library not available. This component needs to be inside a Map context.
	// 			</div>
	// 		</div>
	// 	);
	// }
	return (
		<Autocomplete
			value={inputValue}
			items={suggestionItems}
			placeholder={placeholder}
			className={className}
			isReady={isReady}
			isValueSelected={isValueSelected}
			onInputChange={handleInputChange}
			onItemSelect={handlePlaceSelect}
			onClear={clearInput}
			onValueSelectedChange={setIsValueSelected}
			inputProps={{ "aria-label": "Location", ...(inputProps || {}) }}
			selectedItems={selectedAutocompleteItems}
			onItemRemove={onItemRemove}
			showChips={showChips}
			filterField={filterField}
			autoFocus={autoFocus}
			{...props}
		/>
	);
};

// // The wrapper decides whether to provide the context
// export const PlaceAutocomplete: React.FC<PlaceAutocompleteProps> = props => {
// 	if (props.filterField) {
// 		return <PlaceAutocompleteInner {...props} />;
// 	}
// 	return (
// 		<MapProvider>
// 			<PlaceAutocompleteInner {...props} />
// 		</MapProvider>
// 	);
// };
